module.exports = __webpack_public_path__ + "img/CARACTE3.06222d44.jpg";